'use strict'
import {DOM} from '../../../../../plugins/levcharity/resources/scripts/helpers/DOM'

export class LoginComponent {
    #loginContainer
    #loginPathContainer
    #noticeWrapper
    constructor(){
        this.changeLayout();
        this.#loginContainer = DOM.el('.chaiathon-login-form-container');
        this.#noticeWrapper = DOM.el('.woocommerce-notices-wrapper')
        this.#initPasswordFields()
    }
    changeLayout(){
        const loginContainer = document.querySelector('.chaiathon-login-form-container');
        if(loginContainer){
            const form = loginContainer.querySelector('form.woocommerce-form-login');
            const rememberMeLabel = form.querySelector('label.woocommerce-form-login__rememberme');
            const forgotPasswordLink = form.querySelector('.lost_password');
            const socialLoginButtons = loginContainer.querySelector('.social-login-buttons');
            const submitButton = form.querySelector('button');
            submitButton.textContent = "Log in"

            forgotPasswordLink.querySelector('a').textContent = 'Forgot your password?'
        }
    }

    loginPathHandler(){
        const loginButton = DOM.el('.path-item.login', this.#loginPathContainer)
        const registerButton = DOM.el('.path-item.register', this.#loginPathContainer)
        DOM.addEvent('click', loginButton, (event) => {
            event.preventDefault();
            this.#loginPathContainer.style.display = 'none';
            this.#loginContainer.style.display = 'block';
        })

        DOM.addEvent('click', registerButton, (event) => {
           event.preventDefault();
           const signupUrl = registerButton.getAttribute('data-signup-url')
            window.location.href = signupUrl;
        });
    }

    #initPasswordFields() {
        DOM.addEvent('click', '.show-hide-password', (event, element) => {
            const formGroup = element.closest('.woocommerce-form-login');
            if (!formGroup){
                return;
            }
            const input = formGroup.querySelector("input[name='password'][type='password'], input[name='password'][type='text']");

            if (!input) return;

            input.type = input.type === 'password' ? 'text' : 'password';

            const close = element.querySelector('.closed');
            const open = element.querySelector('.open');

            if (input.type === 'text') {
                if (open) open.style.display = 'none';
                if (close) close.style.display = 'inline';
            } else {
                if (open) open.style.display = 'inline';
                if (close) close.style.display = 'none';
            }
        });
    }


}
